import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import FaceModal from "./modules/FaceModal";
import FaceDrawer from "./modules/FaceDrawer";
import moment from "moment";
export default {
  name: 'StrangerFaceList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    FaceModal: FaceModal,
    FaceDrawer: FaceDrawer
  },
  data: function data() {
    return {
      pagePath: '/ai/face/queryStranger',
      pageTitle: '陌生人预警',

      /* 数据源 */
      dataSource: [],
      // 表头
      columns: [],
      times: [],

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      url: {
        imgerver: window._CONFIG['imgDomainURL']
      }
    };
  },
  created: function created() {
    this.queryParam.type = "3";
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.queryParam.sdate = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.edate = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss');
    this.times = [moment(this.queryParam.sdate, 'YYYY-MM-DD HH:mm:ss'), moment(this.queryParam.edate, 'YYYY-MM-DD HH:mm:ss')];
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;
      console.log(ids[1], ids[0]);

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    onDateTick: function onDateTick(value, dateArray) {
      this.queryParam.sdate = dateArray[0];
      this.queryParam.edate = dateArray[1];
    },
    handleTableChange: function handleTableChange(pagination, filters) {
      this.ipagination.current = pagination;
      this.ipagination.pageSize = filters;
      this.loadData();
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          if (res.result.records != null) {
            res.result.records.forEach(function (e) {
              if (e.createTime != null) {
                e.date = e.createTime.split(' ')[0];
                e.time = e.createTime.split(' ')[1];
              }
            });
            _this.dataSource = res.result.records;
            _this.ipagination.total = res.result.total;
          }
        } else {
          _this.$message_custom('系统异常=>' + res.message, 'warning');
        }

        _this.loading = false;
      });
    },
    detail: function detail(params) {
      this.$refs.modalForm.detail(params);
    },
    getAvatarView: function getAvatarView(srcId) {
      return this.url.imgerver + '/' + srcId;
    },
    handleAdd: function handleAdd() {
      this.$refs.faceDrawer.add();
      this.$refs.faceDrawer.title = '新增：' + this.pageTitle;
      this.$refs.faceDrawer.disableSubmit = false;
      this.$refs.faceDrawer.showTab = false;
      this.$refs.faceDrawer.showContact = false;
      this.$refs.faceDrawer.pagePath = '/ai/face';
    }
  }
};